import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface CanvasSkeletonProps {
  type?: 'default' | 'generate';
}

export const CanvasSkeleton: React.FC<CanvasSkeletonProps> = ({ type = 'default' }) => {
  if (type === 'generate') {
    return (
      <Box sx={{ p: 2 }}>
        {/* Skeleton for Generate Canvas - similar to GenerateProgressCard structure */}
        {[1].map((index) => (
          <Box
            key={index}
            sx={{
              mb: 2,
              p: 2.5,
              backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100',
              borderRadius: 2,
            }}
          >
            {/* Card Title */}
            <Box sx={{ mb: 2 }}>
              <Skeleton variant="text" width="40%" height={28} />
            </Box>

            {/* Progress Items */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {[1, 2, 3].map((itemIndex) => (
                <Box
                  key={itemIndex}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                  }}
                >
                  {/* Icon/Status */}
                  <Skeleton variant="circular" width={24} height={24} />
                  
                  {/* Content */}
                  <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="80%" height={20} />
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    );
  }

  // Default Canvas Skeleton
  return (
    <Box sx={{ p: 2 }}>
      {/* Skeleton for Default Canvas - similar to DefaultProgressCard structure */}
      {[1, 2, 3].map((index) => (
        <Box
          key={index}
          sx={{
            mb: 2,
            p: 2.5,
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'grey.800' : 'grey.50',
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          {/* Card Header */}
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="text" width="30%" height={24} />
          </Box>

          {/* Card Content - Multiple items */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {[1, 2, 3].map((itemIndex) => (
              <Box
                key={itemIndex}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1,
                }}
              >
                {/* Bullet or icon */}
                <Skeleton variant="circular" width={20} height={20} sx={{ mt: 0.25 }} />
                
                {/* Text content */}
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="100%" height={20} />
                  <Skeleton variant="text" width="70%" height={20} />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

